import { render, staticRenderFns } from "./Noise.vue?vue&type=template&id=dd3f1456&scoped=true&"
import script from "./Noise.vue?vue&type=script&lang=js&"
export * from "./Noise.vue?vue&type=script&lang=js&"
import style0 from "./Noise.vue?vue&type=style&index=0&id=dd3f1456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3f1456",
  null
  
)

export default component.exports